import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-light py-5 px-md-5 h-100 w-100 overflow-auto position-relative" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-4 small text-end\" style=\"opacity:.1;\"><p class=\"mb-1\">Obrat za posledních 12 po sobě jdoucích, ukončených měsíců je <span class=\"fw-bold\">344 850,00 Kč</span>. </p><p class=\"mb-1\">Tento měsíc můžete ještě vystavit faktury za <span class=\"fw-bold\">675 100,00 Kč</span>. </p><p class=\"mb-0\">Výpočet: Limit obratu 1 000 000 Kč mínus obrat za posledních 11 uzavřených a aktuální měsíc 324 900,00 Kč = 675 100,00 Kč.</p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_LoadingOverlay = _resolveComponent("LoadingOverlay")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_InvoiceTable = _resolveComponent("InvoiceTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Stats = _resolveComponent("Stats")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SideBar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_LoadingOverlay, { loading: _ctx.loading }, null, 8, ["loading"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PageTitle, {
          title: "Faktury",
          "btn-title": "Nová faktura",
          "btn-click": _ctx.handleAddInvoice
        }, null, 8, ["btn-click"]),
        _createVNode(_component_InvoiceTable, { items: _ctx.items }, null, 8, ["items"]),
        (_ctx.pagination)
          ? (_openBlock(), _createBlock(_component_Pagination, {
              key: 0,
              pagination: _ctx.pagination,
              "route-name": "Invoices"
            }, null, 8, ["pagination"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Stats, { style: {"opacity":".1"} }),
        _hoisted_3
      ])
    ])
  ], 64))
}